/*----- Core -----*/
import { takeLatest, put, call } from 'redux-saga/effects'
import { push }           			 from 'connected-react-router'

/*----- Components -----*/
import Notification from "../../../../components/commons/Notification"

/*----- Constants -----*/
import {
 	DELETE_PRODUCER,
  DELETE_PRODUCER_SUCCESS,
	DELETE_PRODUCER_FAIL
} from './Constants'

import { PRODUCERS, PROFILE_PICS } from '../../../app/Constants'

/*----- Firestore -----*/
import { db, storage } from '../../../../Firebase'

/*----- Resource -----*/

function* shootDeleteProducer(action) {

	let type
	let data = {}

	function* deleteDocument() {
		yield db.collection( PRODUCERS ).doc(action.payload.producerId).delete()
		if (action.payload.producerData.images) {
			yield storage().ref().child(`/${PROFILE_PICS}/${action.payload.producerId}.jpg`).delete()
		}
	}

	try {
		yield call(deleteDocument)
		yield type = DELETE_PRODUCER_SUCCESS
		const doc  = action.payload
		yield data = doc
		yield put(push('/'))
		yield Notification(`Se elimino: ${action.payload.producerData.name} correctamente`, 'success')
	} catch (error) {
		type = DELETE_PRODUCER_FAIL
		data = error.message
		Notification(error.message, 'error')
	}
	
	yield put({type: type, payload: data})

}
export default function* deleteProductWatcher() {
  yield takeLatest(DELETE_PRODUCER, shootDeleteProducer)
}